import styles from "@/_styles/_animation/LogoAnimation.module.css";
import { Icon } from "@chakra-ui/react";
// import { StarLogoIcon } from "@/_images/svgs/chakra-icons/Logo";
import { KnootLogo } from "@/_images/svgs/chakra-icons/KnootLogo";
import { useRouter } from "next/navigation";

interface AnimatedLogoProps {
  color?: string;
  size?: string;
  animate?: boolean;
}

export const AnimatedLogo = ({
  color = "primary.500",
  size = "2rem",
  animate = false,
}: AnimatedLogoProps) => {
  const router = useRouter();

  const handleClick = () => {
    router.push("/");
  };

  return (
    <Icon
      as={KnootLogo}
      boxSize={size}
      cursor="pointer"
      color={color}
      className={animate ? styles.colorCycle : undefined}
      onClick={handleClick}
    />
  );
};
